// import { gsap } from 'gsap';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { timePeriods } from './data';
import { CircleManager } from './CircleManager';
import { SliderManager } from './SliderManager';
import { NavigationManager } from './NavigationManager';
Swiper.use([Navigation]);
export class Timeline {
    constructor(periods = timePeriods) {
        this.periods = periods;
        this.currentIndex = 0;
        this.total = 0;
        this.angleStep = 0;
        this.total = periods.length;
        this.angleStep = 360 / this.total;
    }
    initialize(containerId) {
        const container = document.getElementById(containerId);
        if (!container) {
            return;
        }
        this.container = container;
        this.navigationManager = new NavigationManager(this.container, this.total);
        this.circleManager = new CircleManager(this.container, this.periods);
        this.sliderManager = new SliderManager(this.container);
        this.setupDOM();
        this.setupEvents();
        this.render();
    }
    setupDOM() {
        this.circleManager.setup();
        this.sliderManager.setup();
        this.navigationManager.setup();
    }
    setupEvents() {
        this.navigationManager.setButtonHandlers(() => this.prev(), () => this.next());
        this.circleManager.setOnPointClick((index) => {
            this.goToPeriod(index);
        });
        this.navigationManager.setOnDotClick((index) => {
            this.goToPeriod(index);
        });
    }
    render() {
        const period = this.periods[this.currentIndex];
        this.navigationManager.updateYears(period.period);
        this.navigationManager.updateFraction(this.currentIndex);
        this.navigationManager.updateMobileTitle(period.title);
        this.navigationManager.updateMobileDots(this.currentIndex);
        this.navigationManager.updateButtonsState(this.currentIndex);
        this.circleManager.rotateTo(this.currentIndex, this.angleStep);
        this.circleManager.updateActivePoint(this.currentIndex);
        this.sliderManager.updateSlides(period.events);
    }
    goToPeriod(index) {
        if (index < 0 || index >= this.total || index === this.currentIndex)
            return;
        this.currentIndex = index;
        this.render();
    }
    prev() {
        if (this.currentIndex > 0) {
            this.goToPeriod(this.currentIndex - 1);
        }
        // else {
        //   console.log('Уже на первом');
        // }
    }
    next() {
        if (this.currentIndex < this.total - 1) {
            this.goToPeriod(this.currentIndex + 1);
        }
        // else {
        //   console.log('Уже на последнем');
        // }
    }
}
